import { useCallback, useMemo } from 'react';
import uuid from 'react-uuid';
import PopUpContentWrapper from 'src/components/PopUpContentWrapper';
import Button from 'src/components/design-system/Button';
import PopUp from 'src/components/design-system/PopUp';
import { InvoiceGlBreakoutItem } from 'src/services/useInvoiceGlBreakoutApi';
import { useContextSelector } from 'use-context-selector';
import { InvoiceContext } from './InvoiceDetailsContext';

const AddGlCode = () => {
  const invoice = useContextSelector(InvoiceContext, (value) => value.invoice);
  const isInvoiceInProgress = useContextSelector(
    InvoiceContext,
    (value) => value.isInvoiceInProgress
  );
  const setInvoiceGlCodes = useContextSelector(InvoiceContext, (value) => value.setInvoiceGlCodes);
  const isInvoiceEditDisabled = useContextSelector(
    InvoiceContext,
    (value) => value.isInvoiceEditDisabled
  );
  const lineItemsWithErrorWarningStatus = useContextSelector(
    InvoiceContext,
    (value) => value.lineItemsWithErrorWarningStatus
  );

  const disabled = useMemo(
    () =>
      invoice?.isAutoDistGlBreakout ||
      !isInvoiceInProgress ||
      isInvoiceEditDisabled ||
      lineItemsWithErrorWarningStatus.length === 0,
    [
      invoice?.isAutoDistGlBreakout,
      isInvoiceEditDisabled,
      isInvoiceInProgress,
      lineItemsWithErrorWarningStatus.length,
    ]
  );

  const handleAddGlCode = useCallback(() => {
    setInvoiceGlCodes((prev) => [
      ...prev.slice(0, -1),
      {
        isNewlyAdded: true,
        rowId: uuid(),
        glCode: '',
        discountAmt: 0,
        salesTaxAmt: 0,
        shipCostAmt: 0,
        notes: '',
      } as InvoiceGlBreakoutItem,
      prev[prev.length - 1],
    ]);
  }, [setInvoiceGlCodes]);

  return (
    <PopUp
      popupAlign={{ horizontal: 'center', vertical: 'top' }}
      content={
        <div className="m-1 max-w-[350px]">
          <PopUpContentWrapper
            type="Information"
            contents={['At least one line item is required to add a GL code']}
          />
        </div>
      }
      show={!invoice?.isAutoDistGlBreakout && lineItemsWithErrorWarningStatus.length === 0}
    >
      <Button disabled={disabled} onClick={handleAddGlCode}>
        Add GL Code
      </Button>
    </PopUp>
  );
};

export default AddGlCode;
